import script from "./OrderHistoryPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderHistoryPopup.vue?vue&type=script&setup=true&lang=js"

import "./OrderHistoryPopup.vue?vue&type=style&index=0&id=10960c80&lang=css"

const __exports__ = script;

export default __exports__